type ManageableGroup = { id: string };

type GetAutoSelectedGroupIdArgs = {
  lockGroupSelection: boolean | undefined;
  defaultGroupId: string | undefined;
  isGroupAdmin: boolean;
  manageableGroups: ManageableGroup[];
};

/**
 * The group id to auto-select (and skip the group-assignment step for), per the PRD:
 * Group Details locks a specific group, and a Group admin who manages exactly one
 * group never sees the picker. Returns `undefined` when neither applies, meaning the
 * group-assignment step (Task 5) should render normally.
 */
export const getAutoSelectedGroupId = ({
  lockGroupSelection,
  defaultGroupId,
  isGroupAdmin,
  manageableGroups,
}: GetAutoSelectedGroupIdArgs): string | undefined => {
  if (lockGroupSelection && defaultGroupId) return defaultGroupId;
  if (isGroupAdmin && manageableGroups.length === 1) return manageableGroups[0]?.id;
  return undefined;
};
